import { Button } from 'components/Form/Button/Button';
import { MenuButton, MenuButtonOption } from 'components/MenuButton/MenuButton';
import { Badge, BadgeColor } from 'components/Display/Badge/Badge';
import { useTranslation } from 'react-i18next';
import { ActionConfig, MessageV2DTO } from '../types';

type DestructiveActionProps = {
  action: ActionConfig | null;
  fromDocument: MessageV2DTO;
};

export const DestructiveAction = ({ action, fromDocument }: DestructiveActionProps) => {
  const { t } = useTranslation();

  if (!action) {
    return null;
  }

  if (action.subActions) {
    return (
      <MenuButton
        className="ml-2"
        variant="secondary-danger"
        text={t(action.label)}
        size="base"
        analyticsId="transactions:destructive_actions"
      >
        {action.subActions.map((subAction) => (
          <MenuButtonOption
            analyticsId={subAction.analyticsId}
            key={subAction.label}
            onClick={() => subAction.onClick(fromDocument)}
            className="max-w-72"
          >
            <span className="space-y-2">
              <div className="flex justify-between gap-2">
                <span>{subAction.label}</span>
                {subAction.badge && <Badge color={BadgeColor.purple}>{t(subAction.badge)}</Badge>}
              </div>
              {subAction.description && (
                <span className="block text-sm font-normal text-gray-500">{t(subAction.description)}</span>
              )}
            </span>
          </MenuButtonOption>
        ))}
      </MenuButton>
    );
  }

  return (
    <Button
      className="ml-2"
      variant="secondary-danger"
      onClick={() => action.onClick(fromDocument)}
      testId="ActionButtonDestructiveAction"
      analyticsId="transactions:destructive_action"
    >
      {t(action.label)}
    </Button>
  );
};
